module.exports = __webpack_public_path__ + "img/pr-11.2539e324.png";